export default __webpack_public_path__ + "img/homepage.product.07.asset.929148a6.jpg";